module.exports = __webpack_public_path__ + "img/folder-white.9a403a1d.svg";